import { inject, Injectable } from "@angular/core";
import { Api } from "@services/api.service";

declare global { 
  interface Window { 
    Stripe?: any;
  } 
}

@Injectable({
	providedIn: 'root'
})
export class PaymentService{
	private api: Api=inject(Api);

	payPaypalOrder(order: string){
		return this.api.get<PaypalOrder>(`/orders/${order}/payments/paypal`);
	}

	payStripeOrder(order: string){
		return this.api.get<StripePaymentIntent>(`/orders/${order}/payments/stripe`);
	}

	loadStripeJs(){
		if(window.Stripe)
		  return Promise.resolve(window.Stripe);

		return new Promise((resolve, reject) => {
		  const existing=document.getElementById('stripe-js');
		  if(existing){
		    existing.addEventListener('load', () => resolve(window.Stripe));
		    existing.addEventListener('error', reject);
		  }
		  else{
		    const s=document.createElement('script');
		    s.id='stripe-js';
		    s.src='https://js.stripe.com/v3/';
		    s.async=true;
		    s.onload=() => resolve(window.Stripe);
		    s.onerror=reject;
		    document.head.appendChild(s); 
		  }
		});
	}
}

export interface PaypalOrder{
	url: string;
	orderId: string;
}

export interface StripePaymentIntent{
	clientSecret: string;
	paymentIntentId: string;
}